<template>
  <div class="sp-finder-search-view">
    <slot />
    <Teleport v-if="showLocation" :to="locationTarget">
      <FinderLandingLocation
        ref="locationControl"
        :settings="settings.location"
        :draft="draft"
        :transient-location="draftTransientLocation"
        :active="route === 'landing'"
        @update-location="updateLocation"
      />
    </Teleport>
    <Teleport v-if="showFeatured" :to="featuredTarget">
      <FinderLandingFeaturedNavigation
        :navigation="featuredNavigation"
        @search="featuredSearch"
        @focus-search="focusSearch"
      />
    </Teleport>
  </div>
</template>

<script setup>
import { computed, ref, useTemplateRef } from "vue";
import { useFinderLanding } from "#ce/apps/SpFinderSearchView/composables/useFinderLanding";
import FinderLandingLocation from "#ce/apps/SpFinderSearchView/components/FinderLandingLocation.ce.vue";
import FinderLandingFeaturedNavigation from "#ce/apps/SpFinderSearchView/components/FinderLandingFeaturedNavigation.ce.vue";

import { whenI18nReady as finderCatalogReady } from "#ce/components/SpFinder/i18n";
import { whenI18nReady as filterCatalogReady } from "#ce/shared/filters/i18n";

const catalogsReady = ref(false);

function markCatalogsReady() {
  catalogsReady.value = true;
}

Promise.all([finderCatalogReady, filterCatalogReady]).then(markCatalogsReady);

const locationControl = useTemplateRef("locationControl");
const {
  settings,
  draft,
  draftTransientLocation,
  route,
  locationTarget,
  featuredTarget,
  updateLocation,
  featuredSearch,
  focusSearch,
} = useFinderLanding(locationControl, catalogsReady);
const showLocation = computed(() => {
  const landing = settings.value?.landing;
  const filters = landing?.filters;
  return Boolean(
    catalogsReady.value &&
      locationTarget.value &&
      (!landing?.sections || landing.sections.omnisearch) &&
      landing?.showFilters &&
      filters !== false &&
      (!Array.isArray(filters) || filters.includes("near")),
  );
});
const showFeatured = computed(() => Boolean(featuredNavigation.value?.items?.length && featuredTarget.value));
const featuredNavigation = computed(() => settings.value?.landing.featuredNavigation);
</script>

<style>
:host([hidden]) {
  display: none;
}

:host {
  display: block;
}
</style>
